import type { PlayerTrackPosition } from '@multirx/shared/types/track.js';

export type Live3dResyncAction =
  | { type: 'remove'; playerIndex: number }
  | { type: 'snap'; playerIndex: number; position: PlayerTrackPosition };

/**
 * Planifie le resync 3D à partir de l'état autoritaire (serveur) déjà appliqué
 * en mémoire : les terminés disparaissent, les autres sont snappés à leur case.
 */
export function planLive3dServerResync(args: {
  finished: readonly boolean[];
  positions: readonly PlayerTrackPosition[];
}): Live3dResyncAction[] {
  const n = Math.min(args.finished.length, args.positions.length);
  const actions: Live3dResyncAction[] = [];
  for (let i = 0; i < n; i++) {
    if (args.finished[i]) {
      actions.push({ type: 'remove', playerIndex: i });
    } else {
      actions.push({ type: 'snap', playerIndex: i, position: args.positions[i] });
    }
  }
  return actions;
}
